import React from 'react';
import { ICounterProps } from './Counter.types';
import styles from './Counter.module.css';

const Counter: React.FC<ICounterProps> = ({ current, maxSize }: ICounterProps) => {
  return <div className={styles.counter}>{`${current}/${maxSize}`}</div>;
};

export default Counter;
